module.exports = __webpack_public_path__ + "img/logo-mobile.92156f4d.svg";